module.exports = __webpack_public_path__ + "static/media/CloseIcon.86f2e3a0.svg";